import { commentsData } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            网友热议
          </h2>
          <p className="text-foreground-500 text-sm">看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-col gap-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-foreground-800 font-bold text-sm whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-bold whitespace-nowrap">
                      {comment.tag}
                    </span>
                    <span className="text-foreground-400 text-xs whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-foreground-400 hover:text-primary-500 text-xs cursor-pointer transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1 text-foreground-400 hover:text-primary-500 text-xs cursor-pointer transition-colors">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1 text-foreground-400 hover:text-primary-500 text-xs cursor-pointer transition-colors">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}